import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

import {reactive, ref, provide, nextTick} from 'vue';
import {Toast} from 'vant';
import {useEventListener} from '@vueuse/core';
import SuccessIcon from '@/assets/img/success.svg';
import FailIcon from '@/assets/img/fail.svg';
import useUa from '@/hooks/useUa';


const __default__ = {
  name: 'App',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {isAndroid, isIOS} = useUa();
// 兼容问题, 支持 ios 伪类 :active, 高亮
// 空函数就可以
useEventListener(document.body, 'touchstart', () => ({}));

// 页面刷新
const isRouteAlive = ref(true);

// ios 控制区分 h5 返回和 native 返回
const routeByBtnType = ref<string>('');
const handleRouteByBtn = (type: 'forward' | 'backward') => {
  routeByBtnType.value = type;
  let timer: number | null = setTimeout(() => {
    clearTimeout(timer!);
    timer = null;
    routeByBtnType.value = isIOS ? '' : 'backward';
  }, 200); // 动画为 0.2 S, 延迟置为 false
};
provide('handleRouteByBtn', handleRouteByBtn);

const themeVars = reactive<{
  [key: string]: any;
}>({
  // 按钮
  buttonPrimaryBackgroundColor: '#FE5D53',
  buttonPrimaryBorderColor: '#FE5D53',
  buttonDefaultHeight: '36px',
});

// Toast 全局设置
Toast.setDefaultOptions('success', {icon: SuccessIcon, iconSize: 47});
Toast.setDefaultOptions('fail', {icon: FailIcon, iconSize: 47});

// url上有指定参数, 调端能力返回学习页
// setWebBackScheme('superclass://jump?action_type=learn');


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_config_provider = _resolveComponent("van-config-provider")!

  return (_openBlock(), _createBlock(_component_van_config_provider, { "theme-vars": themeVars }, {
    default: _withCtx(() => [
      (isRouteAlive.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: _unref(isAndroid) || routeByBtnType.value ? routeByBtnType.value : '',
                duration: _unref(isAndroid) || routeByBtnType.value ? 200 : 2000
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_KeepAlive, { max: "10" }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: _ctx.$route.fullPath
                    }))
                  ], 1024))
                ]),
                _: 2
              }, 1032, ["name", "duration"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["theme-vars"]))
}
}

})